<template>
    <div id="preordersrootpopup">
        <vs-popup title="" 
        :button-close-hidden="true" 
        :active.sync="isActive"
        @close="$emit('isActiveFalse')"
        style="border-radius: 10px !important;"
        id='popUpPreOrdersChat'
        >
            <div>
                <span id="display-span-orders">
                    <!--<vs-icon class="mr-2" icon="keyboard_arrow_left" style="border: solid 1px; border-radius: 14px; cursor: pointer;"/>-->
                    <p class="ml-6" style="font-size: 16px; width: 150px;">
                      Orçamentos
                    </p>
                    <div class="flex-end-align">
                        <vs-icon
                            @click="closePopUp"
                            class="mr-2"
                            icon="close"
                            style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right;"
                        ></vs-icon>
                    </div>
                </span>
            </div>

            <pre-orders-table
                ref="preOrdersTable"
                @closePopup="closePopUp"
                @turnIntoOrder="turnIntoOrder"
                @createPreOrder="createPreOrder"
                :customerId="customerId"
            ></pre-orders-table>
        </vs-popup>
    </div>
</template>

<script>
    import PreOrdersTable from "./PreOrdersTable";

    export default {
        name: 'PreOrdersPopUp',
        components: {
            PreOrdersTable
        },
        data() {
            return {
                isMounted: false
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            customerId: {
                type: Number,
                required: false,
                default: null
            },
        },
        emits: [
            'isActiveFalse',
            'turnIntoOrder',
            'createPreOrder'
        ],
        methods: {
            async dataLoad() {
                await this.$refs.preOrdersTable.dataLoad();
            },
            closePopUp() {
                this.isActive = false;
                this.$emit('isActiveFalse');
            },
            turnIntoOrder(data) {
                this.$emit('turnIntoOrder', data);
            },
            createPreOrder(data) {
                this.$emit('createPreOrder', data);
            }
        },
        async mounted() {
            this.$store.dispatch('setShowLoadingOverlay', false)

            await this.dataLoad();
            this.isMounted = true;
        },
        watch: {
            isActive() {
                this.dataLoad();
            }
        },
    }
</script>

<style lang="scss">
#popUpPreOrdersChat div.vs-popup {
    .vs-popup--content {
        padding: 15px;
        margin: 0;
    }
    margin: 0;
    border-radius: 18px !important;
    border: solid 1.2px;
    border-color: rgba(18, 17, 17, 0.769);
    width: 900px !important;
    .vs-popup--header {
        background-color: transparent !important;
        .vs-popup--title {
            background-color: transparent !important;
            h3 {
                background-color: transparent !important;
            }
        }
    }
    header {
        background-color: transparent !important;
    }
}
.ajuste-div-add-new-pre-order {
    button {
        display: flex;
        border-radius: 15px;
        padding: 0px 16px 0px 25px;
        justify-content: center;
    }
    .vs-button-text.vs-button--text {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }   
}
</style>